export default {
  header: 'Utilities',
};
